import styled from '@emotion/styled';

const RowWrapper = styled.div`
  display: flex;
  width: 100%;
`;

export { RowWrapper };
